import React, { useState, useEffect } from 'react';
import './rpt_ejecucion_tabla.css'

const TablaEjecucionBloque = (p) => {
    const [seleccionesLocal, setseleccionesLocal] = useState({ index: -1 });
    const [reporteFormato, setreporteFormato] = useState([]);

    useEffect(() => {
        setseleccionesLocal({ index: -1 });
        formatearReporte();
    }, [p.datos]);

    const formatearReporte = () => {
        const datos = p.datos ?? [];
        const formato = {};
        for (const item of datos) {
            if (!formato[item.bloque]) {
                formato[item.bloque] = {
                    bloque: item.bloque,
                    total_plan_charolas: 0,
                    total_ejecutado_charolas: 0,
                    total_plan_plantas: 0,
                    total_ejecutado_plantas: 0,
                    total_semanas: 0,
                    semanas_array: [],
                    semanas: {}
                };
            }
            formato[item.bloque].total_plan_charolas += item.total_plan ?? 0;
            formato[item.bloque].total_ejecutado_charolas += item.total_ejecutado ?? 0;
            formato[item.bloque].total_plan_plantas += (item.total_plan ?? 0) * (item.cavidad ?? 0);
            formato[item.bloque].total_ejecutado_plantas += (item.total_ejecutado ?? 0) * (item.cavidad ?? 0);
            const semana = item.semana_siembra;

            if (!formato[item.bloque].semanas[semana]) {
                formato[item.bloque].semanas[semana] = {
                    semana: semana,
                    total_plan_charolas: 0,
                    total_plan_plantas: 0,
                    total_ejecutado_charolas: 0,
                    total_ejecutado_plantas: 0,
                    datos: []
                };
                formato[item.bloque].total_semanas += 1;
                formato[item.bloque].semanas_array.push(semana);
            }
            formato[item.bloque].semanas[semana].total_plan_charolas += item.total_plan ?? 0;
            formato[item.bloque].semanas[semana].total_ejecutado_charolas += item.total_ejecutado ?? 0;
            formato[item.bloque].semanas[semana].total_plan_plantas += (item.total_plan ?? 0) * (item.cavidad ?? 0);
            formato[item.bloque].semanas[semana].total_ejecutado_plantas += (item.total_ejecutado ?? 0) * (item.cavidad ?? 0);
            formato[item.bloque].semanas[semana].datos.push(item);
        }
        setreporteFormato(Object.values(formato));
    }

    const formatoCommas = (numero) => {
        if (numero === null || numero === undefined || Number.isNaN(Number(numero))) {
            return '0';
        }

        return Number(numero).toLocaleString('en-US');
    }

    return (
        <table className='table table-sm' >
            <thead>
                <tr>
                    <th scope='col' className='text-start'>BLOQUE</th>
                    <th scope='col' className='text-end'>PLAN CH.</th>
                    <th scope='col' className='text-end'>PLAN PL.</th>
                    <th scope='col' className='text-end'>EJECUTADO CH.</th>
                    <th scope='col' className='text-end'>EJECUTADO PL.</th>
                    <th scope='col' className='text-center'>AVANCE</th>
                    <th scope='col' className='text-center'>SEMANAS INCLUIDAS</th>
                </tr>
            </thead>
            <tbody>
                {reporteFormato.length === 0 && (
                    <tr>
                        <td colSpan="7" className="text-center th h2 text-300">No hay datos disponibles</td>
                    </tr>
                )}
                {
                    reporteFormato.map((bloque, index) => (
                        <React.Fragment key={index}>
                            <tr className={`${seleccionesLocal.index !== -1 && seleccionesLocal.index !== index ? 'tr-semitrasparent' : 'tr'}`} onClick={() => setseleccionesLocal({ index: seleccionesLocal.index === index ? -1 : index })}>
                                <td scope='row' className='th'>{bloque.bloque}</td>
                                <td className='text-300 text-end th'>{formatoCommas(bloque.total_plan_charolas)} Ch</td>
                                <td className='text-300 text-end th'>{formatoCommas(bloque.total_plan_plantas)} Pl</td>
                                <td className='text-bold text-end th'>{formatoCommas(bloque.total_ejecutado_charolas)} Ch</td>
                                <td className='text-bold text-end th'>{formatoCommas(bloque.total_ejecutado_plantas)} Pl</td>
                                <td className='text-center th'>{(bloque.total_plan_charolas !== 0 ? (bloque.total_ejecutado_charolas / bloque.total_plan_charolas) * 100 : 0).toFixed(2)}%</td>
                                <td className='text-center th'>{bloque.semanas_array.join(', ')}</td>
                            </tr>
                            {seleccionesLocal.index !== -1 && seleccionesLocal.index === index && (
                                <tr>
                                    <td colSpan="7" className="text-center th">
                                        <table className='table table-sm table-hover text-s'>
                                            <thead>
                                                <tr>
                                                    <th scope='col text-s'>S. SIEMBRA</th>
                                                    <th scope='col'>S. TRASPL./CORTE</th>
                                                    <th scope='col'>TOTAL EJEC.</th>
                                                    <th scope='col'>LUNES</th>
                                                    <th scope='col'>MARTES</th>
                                                    <th scope='col'>MIÉRCOLES</th>
                                                    <th scope='col'>JUEVES</th>
                                                    <th scope='col'>VIERNES</th>
                                                    <th scope='col'>SÁBADO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bloque.semanas_array.map((semana, i) => bloque.semanas[semana].datos.map((semanaDatos, j) => (
                                                    <tr key={i}>
                                                        <td className="text-bold">{semanaDatos.semana_siembra}</td>
                                                        <td>{semanaDatos.semana_trasplante} <span className='ms-2 me-2 text-bold opacity-40'>|</span>{semanaDatos.semana_corte}</td>
                                                        <td >
                                                            {formatoCommas(bloque.semanas[semana].total_ejecutado_charolas)}<span className='text-xs text-300 me-3 ms-1'>Ch.</span>
                                                            {formatoCommas(bloque.semanas[semana].total_plan_plantas)}<span className='text-xs text-300 ms-1'>Pl.</span>
                                                        </td>
                                                        <td className={semanaDatos.lunes ? 'text-bold text-blue3' : ''}>{formatoCommas(semanaDatos.lunes)}</td>
                                                        <td className={semanaDatos.martes ? 'text-bold text-blue3' : ''}>{formatoCommas(semanaDatos.martes)}</td>
                                                        <td className={semanaDatos.miercoles ? 'text-bold text-blue3' : ''}>{formatoCommas(semanaDatos.miercoles)}</td>
                                                        <td className={semanaDatos.jueves ? 'text-bold text-blue3' : ''}>{formatoCommas(semanaDatos.jueves)}</td>
                                                        <td className={semanaDatos.viernes ? 'text-bold text-blue3' : ''}>{formatoCommas(semanaDatos.viernes)}</td>
                                                        <td className={semanaDatos.sabado ? 'text-bold text-blue3' : ''}>{formatoCommas(semanaDatos.sabado)}</td>
                                                    </tr>
                                                )))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))
                }
            </tbody>
        </table>
    )
}

export default TablaEjecucionBloque;